@if (isVisible) {

  <div fxLayout="row" fxLayoutAlign="center">
    <h3>New Request to Intervene</h3>
  </div>

  <form #intervenorForm="ngForm" class="full-height">

    <mat-card>
      <mat-card-header style="margin-bottom: 20px;">
        <mat-card-title>Intervenor</mat-card-title>
      </mat-card-header>

      <mat-card-content fxLayout="row wrap" fxLayoutGap="8px">

        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Company Name</mat-label>
          <input matInput name="intervenorCompanyName" [(ngModel)]="intervenorCompanyName" required>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always" *ngIf="stateService.userRole === UserRole.GAO_Admin">
          <mat-label>Email Address</mat-label>
          <input matInput name="intervenorEmailAddress"
                 matTooltip="Enter email address associated wtih EPDS"
                 [(ngModel)]="intervenorEmail"  #intervenorEmailAddress="ngModel" email appEmailExist [existsError]="false" required>
          <mat-error *ngIf="intervenorForm?.controls?.['intervenorEmailAddress']?.errors?.['exists'] === false">Email address is not a valid EPDS user account</mat-error>
          <mat-error *ngIf="!intervenorForm?.controls?.['intervenorEmailAddress']?.errors?.['exists']">Required</mat-error>
        </mat-form-field>

      </mat-card-content>
    </mat-card>

    <mat-card>
      <mat-card-header style="margin-bottom: 20px;">
        <mat-card-title>Company Address</mat-card-title>
        <br/>
      </mat-card-header>

      <mat-card-content fxLayout="row wrap" fxLayoutGap="8px">

        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Address Line 1</mat-label>
          <input matInput name="intervenorAddress1" [(ngModel)]="intervenorAddress1" required
                 appGmapAutocom (selectedPlace)="newIntervenorPlaceChanged($event)">
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Address Line 2</mat-label>
          <input matInput name="intervenorAddress2" [(ngModel)]="intervenorAddress2">
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>City</mat-label>
          <input matInput name="intervenorCity" [(ngModel)]="intervenorCity" required>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>State</mat-label>
          <input matInput name="intervenorState" [(ngModel)]="intervenorState" required>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Zip Code</mat-label>
          <input matInput name="intervenorZipCode" [(ngModel)]="intervenorZipCode" required>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Country</mat-label>
          <input matInput name="intervenorCountry" [(ngModel)]="intervenorCountry" required>
        </mat-form-field>

      </mat-card-content>
    </mat-card>

    <mat-card>
      <mat-card-header style="margin-bottom: 20px;">
        <mat-card-title>Documents</mat-card-title>
        <br/>
      </mat-card-header>

      <mat-card-content fxLayout="column" fxLayoutGap="10px">


        <!-- File Upload Component -->
        <mat-form-field floatLabel="always" appearance="outline" style="width: 100%">
          <mat-label>Upload Request to Intervene Document (Only PDF and Excel files can be attached)</mat-label>
          <input matInput style="display: none" required/>

          <app-file-upload #fileUpload
                           [fileUploadInProgress]="fileUploadInProgress"
                           [wrongFileTypeMessage]="uploadDocMessage"
                           [requiredFileType]="requiredFileType"
                           [showAssociatedDocuments]="false"
                           (attachAssociatedDocOutput)="attachAssociatedDocOutput = $event"
                           (primaryEPDSFileListOutput)="onEPDSFileListChange($event, 'P')">
          </app-file-upload>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Comments</mat-label>
          <textarea matInput #intervenorCommentsInput name="intervenorComments" maxlength="250" [(ngModel)]="intervenorComments"></textarea>
          <mat-label> ( Characters Remaining: {{ intervenorCommentsInput.value.length }} / 250 )</mat-label>
        </mat-form-field>

      </mat-card-content>

      <mat-card-footer>

        <mat-card-actions fxLayout="row" fxLayoutAlign="center" fxLayoutGap="10px">
          <button mat-raised-button color="primary" class="spinner-black"
                  [disabled]="fileUploadInProgress || !(intervenorForm.dirty && intervenorForm.valid) || (primaryFiles.length === 0)"
                  (click)="onIntervenorSubmit()">
            <div *appSpinner="fileUploadInProgress"></div>
            Submit
          </button>
          <button mat-raised-button color="warn" (click)="onIntervenorCancel()">
            Cancel
          </button>
        </mat-card-actions>

      </mat-card-footer>
    </mat-card>

  </form>

}
